export default __webpack_public_path__ + "static/media/Imagen_Conexion_MCP_con_las_LLM.118a470a.png";